import { matchPath } from 'react-router-dom';

import { destroyToken } from '@helpers/user';
import { history, vsuiteRoutes } from '@routes';

/**
 * Removes access and refresh tokens and redirects to login.
 */
const redirectToLogin = () => {
  destroyToken();

  if (!matchPath(history.location.pathname, { path: vsuiteRoutes.LOGIN.rule, exact: true })) {
    history.push(vsuiteRoutes.LOGIN.make());
  }
};

export default redirectToLogin;
